/**
 * BusinessGraphTab.tsx - Top-level tab for Business Graph visualization
 *
 * This is a dedicated tab (alongside Strategy Workspace and Analysis Report)
 * that provides an interactive visualization of the Biz_Ontology graph.
 */

import { useAppSelector } from '@state/hooks'
import { BusinessGraphRenderer } from '@components/workspace/visualizations/BusinessGraphRenderer'
import './BusinessGraphTab.css'

function BusinessGraphTab() {
  const { activeConversationId, conversations } = useAppSelector(state => state.conversations)
  const activeConversation = conversations.find(c => c.id === activeConversationId)
  const workspaceData = activeConversation?.strategyWorkspaceData

  // Check if we have any exploration context
  const hasExplorationContext = !!(
    workspaceData?.graphContext ||
    workspaceData?.graphView ||
    workspaceData?.comprehensiveGate?.data?.graph_context
  )

  if (!activeConversationId) {
    return (
      <div className="business-graph-tab-empty">
        <div className="empty-message">
          <h2>Business Graph</h2>
          <p>Interactive visualization of the Business Ontology</p>
          <p className="hint">Select a conversation to view exploration data</p>
        </div>
      </div>
    )
  }

  return (
    <div className="business-graph-tab">
      <div className="graph-tab-content">
        <BusinessGraphRenderer
          height={700}
          showFilters={true}
          showStats={true}
          showInsights={true}
          autoZoom={hasExplorationContext}
        />
      </div>
    </div>
  )
}

export default BusinessGraphTab
